// Shared by useInstallPrompt and usePushNotifications -- both need to know
// whether the app is running installed (standalone) and whether the browser
// is iOS Safari, which lacks both beforeinstallprompt and (unless installed)
// the Push API.
export const isStandalone = () =>
  window.matchMedia('(display-mode: standalone)').matches ||
  window.navigator.standalone === true;

export const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);
